export const ratio = 1.205;
export const baseFontSize = 15;

/**
 *  Janne design font weights
 */
export const regular = 400;
export const bold = 700;

/**
 *  Old design font sizes
 */
export function fontSizeNumber(step: number) {
  // OA: Below are shorthands for the values calculated with baseFontSize 15 and ratio 1.205, rounded to
  // the nearest integer. Just in case you want to understand what a specific value in the old
  // design system actually means.
  // switch (step) {
  //   case -2:
  //     return 10;
  //   case -1:
  //     return 12;
  //   case 0:
  //     return 14;
  //   case 1:
  //     return 18;
  //   case 2:
  //     return 22;
  //   case 3:
  //     return 26;
  //   case 4:
  //     return 32;
  //   case 5:
  //     return 38;
  //   case 6:
  //     return 46;
  //   case 7:
  //     return 55;
  //   case 8:
  //     return 67;
  // }

  const size = baseFontSize * Math.pow(ratio, step);
  return size;
}

export function fontSize(step: number) {
  return `font-size: ${fontSizeNumber(step)}px;`;
}

export function fontSizeString(step: number) {
  return `${fontSizeNumber(step)}px`;
}

export function disableTextSelection() {
  // from https://stackoverflow.com/questions/826782/how-to-disable-text-selection-highlighting
  return `
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                        supported by Chrome and Opera */
`;
}
